var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "documents.overview.tab.margin.LinkCustomEntryForm.add_profit_entry"
      ),
      closeOnClickOverlay: false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c(
                  "el-form",
                  {
                    ref: "linkCustomEntryForm",
                    attrs: { labelPosition: "top" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "documents.overview.tab.margin.descirption"
                          ),
                          prop: "label",
                          error: _vm.errors.get("label")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { name: "label", maxlength: "255" },
                          model: {
                            value: _vm.label,
                            callback: function($$v) {
                              _vm.label = $$v
                            },
                            expression: "label"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "documents.overview.tab.margin.LinkCustomEntryForm.unit_amount_exclude_tax"
                          ),
                          prop: "amounttaxefree",
                          error: _vm.errors.get("amounttaxefree")
                        }
                      },
                      [
                        _c("input-number", {
                          staticClass: "w-2",
                          attrs: {
                            precision: _vm.unitNumberFormat.precision,
                            separatorDecimal: _vm.unitNumberFormat.decimal,
                            separatorThousand: _vm.unitNumberFormat.thousand
                          },
                          model: {
                            value: _vm.amounttaxefree,
                            callback: function($$v) {
                              _vm.amounttaxefree = $$v
                            },
                            expression: "amounttaxefree"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.quantity"),
                          prop: "qt",
                          error: _vm.errors.get("qt")
                        }
                      },
                      [
                        _c("input-number", {
                          staticClass: "w-2",
                          attrs: {
                            name: "qt",
                            min: 0.01,
                            controls: false,
                            precision: _vm.numberFormat.precision,
                            separatorDecimal: _vm.numberFormat.decimal,
                            separatorThousand: _vm.numberFormat.thousand
                          },
                          model: {
                            value: _vm.qt,
                            callback: function($$v) {
                              _vm.qt = $$v
                            },
                            expression: "qt"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "documents.overview.tab.margin.LinkCustomEntryForm.total_exclude_tax"
                          ),
                          prop: "totalamount",
                          error: _vm.errors.get("totalamount")
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$filters.numberFormat(_vm.total)) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                }),
                _vm._v(" "),
                _vm.customIsEmpty
                  ? _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.save"),
                        type: "primary",
                        disabled: _vm.saveBtnIsdisabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  : _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__(
                          "documents.overview.tab.margin.LinkCustomEntryForm.update"
                        ),
                        type: "primary",
                        disabled: _vm.saveBtnIsdisabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.edit()
                        }
                      }
                    })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }